module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_8.125fbcd6.png";